var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{on:{"click":function (){this$1.visible=true}}},[_vm._t("default")],2),_c('el-dialog',{attrs:{"visible":_vm.visible,"title":"提现审核","width":"100%","center":""},on:{"update:visible":function($event){_vm.visible=$event},"open":_vm.onOpen}},[_c('div',{staticStyle:{"width":"100%","height":"1000px"},attrs:{"id":_vm.id}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }